

import { getUserByIdLoading, getUserByIdSuccess, getUserByIdFailure } from "@redux/slices/userSlice.js"
import { getUserById } from "@services/user/getUserById.js"
import { useDispatch } from "react-redux"

const useUser = () => {
  const dispatch = useDispatch()

  const handleGetUserById = async () => {
    const userId = localStorage.getItem("userId")
    if (!userId) {
      console.error("User ID not found in local storage")
      return
    }

    try {
      dispatch(getUserByIdLoading())
      const response = await getUserById(userId)
      dispatch(getUserByIdSuccess(response.data.data))
    } catch (error) {
      dispatch(getUserByIdFailure())
      console.log(error)
    }
  }

  return { handleGetUserById }
}

export default useUser
